<template>
  <div>
    <div class="bg-purple-light">
      <div class="content">
        <Navbar :is-logged-in="false" />

        <div class="d-flex justify-content-center">
          <div class="white-box my-5">
            <div class="d-flex justify-content-center mx-3 mt-5 p-5">
              <img
                class="image"
                src="@/assets/image/success-reg.png"
                alt="success-reg"
              >
            </div>
            <h4 class="text-center">
              <strong>
                {{ $t("success-register.text-one") }}
              </strong>
            </h4>
            <p class="text-center text-two text-break">
              {{ $t("success-register.text-two") }}
            </p>
            <div class="mx-5 px-5 mt-5">
              <div class="mx-md-5 px-md-5">
                <div class="mx-md-5 px-md-4">
                  <div
                    class="btn btn-info btn-block mt-3 mb-5 py-2"
                    @click="backProcess"
                  >
                    <small class="font-weight-bold">
                      {{ $t("success-register.back") }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/utils/Api'
import Navbar from '@/components/Navbar'

export default {
  name: 'Successregister',

  components: {
    Navbar
  },

  methods: {
    async fetchProfile () {
      const { data } = await Api.users.me()
      localStorage.setItem('profile', JSON.stringify(data))
    },
    backProcess () {
      const hrisAccount = JSON.parse(localStorage.getItem('HRISAccount'))
      const token = localStorage.getItem('token')
      localStorage.removeItem('PersonalData')
      localStorage.removeItem('HRISAccount')
      localStorage.removeItem('Registration')
      if (hrisAccount) {
        localStorage.data = localStorage.getItem('HRISAccount')
        localStorage.token = hrisAccount.token
        localStorage.refreshToken = hrisAccount.refreshToken
        localStorage.login = true
        this.fetchProfile()
        this.$router.push({
          name: 'success-login'
        })
      } else {
        this.$router.push({
          name: token ? 'user-management' : 'login'
        })
      }
    }
  }
}
</script>

<style scoped>
.content {
  background-image: url("../assets/image/bg-2.png");
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: contain;
  min-height: 100vh;
}
.white-box {
  background: white;
  width: 700px;
  border-radius: 18px;
  margin: auto;
  min-height: 597px;
}
.image {
  width: 250px;
}
.text-two {
  color: #AAAAAA;
}
.button {
  width: 20px;
}
.button > .back {
  background-color: #18B2BD;
}
</style>
